import { Box, Image } from "@chakra-ui/react"

export function Nopage(){
    return <>
      <Box>
     <Image src="https://colorlib.com/cdn-cgi/image/width=1200,height=686,fit=crop,quality=80,format=auto,onerror=redirect,metadata=none/wp-content/uploads/sites/2/404-error-page-templates.jpg"></Image>
     </Box>
    </>
}